<!--
 * @Author: wangJiaXiang
 * @Date: 2021-05-28 09:28:08
 * @LastEditors: xuhuining
 * @Description: 医生主页
-->
<template>
  <div>
    <go-back @goBack="goBack" />
    <!-- 医生介绍 -->
    <div class="doctor_introduce">
      <!-- 按钮返回 -->
      <!-- <div class="back"><van-icon name="arrow-left" @click="goBack" /></div> -->

      <span class="gobackBtn" @click="goBack"><img src="@/assets/images/icon/back1.png" alt=""></span>
      <div
        class="doctor_bgimg"
        v-lazy:background-image="doctorInfo.urlTwo"
      ></div>
      <div class="doctor_info">
        <h2 class="ex_name">
          <span class="name">{{ doctorInfo.authorName }}</span
          ><span class="position">{{ doctorInfo.authorTitle }}</span>
        </h2>
        <p class="ex_intro" v-if="doctorInfo.authorDesc !== ''">
          <span class="introductionText">{{
            doctorInfo.authorDesc | exIntroFilter
          }}</span>
          <span
            v-if="
              doctorInfo.authorDesc && doctorInfo.authorDesc.length >= 55
            "
            v-show="openShow"
            class="more"
            @click="openMore(doctorInfo.authorDesc, 0)"
            >展开</span
          >
          <span
            v-show="!openShow"
            class="more"
            @click="openMore(doctorInfo.authorDesc, 1)"
            >收起</span
          >
        </p>
      </div>
    </div>
    <!-- 播放器列表 -->
    <div class="audioList">
      <div class="audioListTitle" @click="playAll">
        <img src="@/assets/images/icon/audio_start.png" alt="" />
        <p>播放全部</p>
      </div>
      <!-- 列表数据 -->
      <div class="audioLists">
        <van-list
          v-model="pageParams.loading"
          :finished="pageParams.audioFinished"
          :finished-text="bottomText"
          error-text="请求失败，点击重新加载"
          :error.sync="pageParams.error"
          @load="getDataList"
        >
          <div
            class="audioItem"
            v-for="(item, index) in audioList"
            :key="index"
          >
            <div class="leftImg">
              <img :src="item.coverUrl" />
              <img
                :class="[item.isPlay ? 'playing' : '', 'play']"
                @click="startPlay(item, index)"
                :src="item.isPlay ? playDoctor : off"
                alt=""
              />
            </div>
            <div class="titleText" @click="onLinkTap(item, index, doctorId)">
              <div>
                <p>{{ item.name }}</p>
                <p>
                  <span>
                    <img src="~@assets/images/icon/audio_time.png" alt="" />
                    {{ item.durationStr || "00:00" }}
                  </span>
                  <span>
                    <img src="~@assets/images/icon/audio_play.png" alt="" />
                    {{ fomatterNum(item.watchNum) || 0 }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <!-- 播放器组件 -->
    <my-Music
      ref="musicAudio"
      @addPalyNum="addPlayNums"
      @playSensor="playSensor"
      @listenLogin="listenLogin"
      :doctorName="doctorName || ''"
      @senDetail="senDetail"
      :playTime="playTime"
      @audio-end="audioEvenTend"
      @pauseaudioparams="PauseaudioParams"
      @playaudioparams="PlayaudioParams"
      :audioParams="audioParams"
    ></my-Music>
    <!-- 置顶 -->
    <to-Top />
    <logintip
      @confirmWay="confirmWay"
      :show="checkLogin"
      @cancleWay="cancleWay"
    />
    <back-xmh @goHomeTap="goHomeTap" v-if="showShareCagechild"></back-xmh>
  </div>
</template>

<script>
import { audioMixins } from "@/minxs/audio.js"; //混入音频公共逻辑
import backXmh from "../cageChild/component/backxmh"; //返回星妈会图标组件
import {
  getCookie,
  fomatterNum,
  TestUserAgent,
  isUserLogin,
  MakeDurationToSeconds,
  globalGoLogin
} from "@/assets/js/common.js"; //引入公共js
import myMusic from "@/components/contents/parentingAudio/parentingAudio_1.0.vue"; //引入播放器组件
import toTop from "@/components/common/toTopKaiqi.vue"; //凯琪育儿置顶组件
import API_KAQI from "@/utils/axiosApi/cageChildApi.js"; //apil 凯奇育儿
import logintip from "@/views/contents/calendar/component/logintip"; //注册提示组件
import goBack from "@/components/common/goBack"; //返回组件
export default {
  name: "doctorHome",
  components: {
    myMusic,
    toTop,
    logintip,
    goBack,
    backXmh,
  },
  props: [],
  mixins: [audioMixins],
  data() {
    return {
      checkLogin: false, //未注册弹窗
      openShow: true, //展开收起
      doctorInfo: {}, //医生信息
      audioParams: {}, //首次传给音频组件信息
      bottomText: "", //触底提示
      audioList: [], //音频总数据
      // 分页参数
      pageParams: {
        page: 1,
        size: 25,
        error: false,
        loading: false,
        audioFinished: false,
      },
      //最新音频分页参数
      newPageParams: {
        page: 1,
        size: 25,
      },
      playIndex: 0, //记录每次播放的下标
      playTime: 0, // 播放时间
      type: "doctorHome",
      doctorId: 0,
      doctorName: "", //埋点医生name
      showTip: false,
      isId: 0, //添加播放量音频判断
      allNewAudio: [], //最新的音频数据
      list: [], //最新的音频跟列表音频切换
      totalElements: 0, //音频总量
      index: null, //分页音频下标
      isStatus:0
    };
  },
  computed: {
    showShareCagechild() {
      return this.$route.query.share === "cagechild";
    },
  },
  watch: {
    audioParams: {
      handler(newValue, oldValue) {
        if (newValue) {
          //切换添加播放量
          if (newValue.id != this.isId && newValue.isPlay) {
            this.addPlayNums(newValue.id);
          }
          if (newValue.isPlay == true) {
            this.doctorName = this.doctorInfo.authorName;
            newValue.isKq = "kq";
          }
        }
      },
      deep: true,
    },
  },
  beforeDestroy(){
    this.$refs.musicAudio.$refs.player.currentTime = 0
    this.$refs.musicAudio.clearTime()

  },
  created() {},
  mounted() {
    if (this.showShareCagechild) {
      this.goHomeSensor("曝光");
    }
    this.getNewAudio();
    //医生id获取医生下音频
    this.doctorId = this.$route.query.id;
    var shareDataParams = {
      shareLink: window.location.href,
      shareDesc: "超1000万中国家庭都在看，快乐育儿，全程陪伴，源于母爱。",
      shareTitle: "星妈会-凯淇育儿",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },
  methods: {
    getCookie,
    fomatterNum,
    goHomeTap() {
      this.goHomeSensor("点击");
      this.$router.push({
        path: "/home",
      });
    },
    goHomeSensor(msg) {
      sensors.track("buoy", {
        button_name: msg,
      });
    },
    listenLogin() {
      if (isUserLogin()) {
        this.$refs.musicAudio.operation();
        //  this.$refs.audio.startPlayer()
        this.checkLogin = true;
      }
    },
    confirmWay() {
      this.checkLogin = false;
      globalGoLogin()
      // 未注册用户弹窗确定埋点
      this.loginRegistSensors("确定");
    },
    loginRegistSensors(msg) {
      sensors.track("Login_registration_pop_up", {
        operation: msg,
        page_name: '凯淇育儿'
      });
    },
    cancleWay() {
      this.checkLogin = false;
      // 未注册用户弹窗取消埋点
      this.loginRegistSensors("取消");
      this.$refs.musicAudio.setAudioTime();

      // this.$refs.audio.startPlayer()
    },
    // 展开医生介绍
    openMore: function (text, type) {
      if (type == 0) {
        $(".introductionText").html(text);
        this.openShow = false;
      } else {
        if (text && text.length >= 55) {
          $(".introductionText").html(text.substring(0, 55) + "...");
        } else {
          $(".introductionText").html(text);
        }
        this.openShow = true;
      }
    },
    playSensor(name){
      console.log(this.audioParams)
      let total = MakeDurationToSeconds(this.audioParams.durationStr);
      let num = this.$refs.musicAudio.current / total;
      let time=this.audioParams.durationStr.split(":")[0]*60+this.audioParams.durationStr.split(":")[1]*1-1
      sensors.track("Audio_and_video_playback", {
        content_id:String(this.audioParams.id) ,
        content_title: this.audioParams.name,
        length_of_time: time,
        content_topic: this.audioParams.audioClassify ? this.audioParams.audioClassify : '',
        position: 0,
        video_duration:String(this.$refs.musicAudio.current) ,
        is_finished: num >= 0.8 ? true : false,
        Content_column: "凯淇育儿",
        doctor:this.doctorName,
        Playback_status: name
      });
    },
    //音频播放量添加
    addPlayNums(id) {

      if (id == this.isId) {
        return false;
      }
      API_KAQI.addPlayNum(id,res=>{
        this.isId = id
      })

    },
    // 返回上一页
    goBack: function () {
      this.$router.push("/cagechild");
    },
    /**
     * 获取凯琪音频列表数据
     */
    getDataList(type = "", callback) {
      API_KAQI.getkqDoctorAudioDetail(
        {},
        {
          authorId: Number(this.doctorId),
          page: this.pageParams.page,
          size: this.pageParams.size,
        },
        (res) => {
          this.pageParams.loading = false;
          if (res.code == 200) {
            this.doctorInfo = res.data.expertManage;
            var arrList = res.data.listKqAudio.data;
            arrList.forEach((item, index) => {
              //为每一项{}添加一个播放标识 默认为false
              item.isPlay = false;
            });
            this.audioList = this.audioList.concat(arrList);
            //更改对象属性名
            this.audioList = JSON.parse(
              JSON.stringify(this.audioList).replace(
                /contentUrl/g,
                "audioAddress"
              )
            );
            //医生浏览埋点
            sensors.track("EnterExpertPage", {
                expert_name:this.doctorInfo.authorName,
                expert_hospital:'',
                expert_level:this.doctorInfo.authorTitle,
                page_name:'凯淇育儿-医生主页',
            });
            if (this.pageParams.page == 1) {
              if (res.data.listKqAudio.data.length == 0) {
                this.bottomText = "";
              } else {
              }
            }
            const HASMORE =
              res.data.listKqAudio.total == 0 ||
              this.pageParams.page >=
                Math.ceil(
                  res.data.listKqAudio.total / this.pageParams.size
                );
            if (HASMORE) {
              this.pageParams.audioFinished = true;
              this.bottomText = "——已经到底了哦——";
            } else {
              this.pageParams.page += 1;
            }
            // type为1 判断当前播放是否到最后一页
            if (type === 1) {
              if (HASMORE) {
                this.playIndex = 0;
              } else {
                this.playIndex++;
              }
              // this.audioParams = this.audioList[this.playIndex];
            }
            callback(res);
          } else {
            this.$toast("网络异常");
            this.pageParams.loading = false;
            this.pageParams.error = true;
          }
        }
      );
    },
    //获取最新音频
    getNewAudio(type = "", callback) {
      API_KAQI.getNewAudio(
        {},
        { page: this.newPageParams.page, size: this.newPageParams.size },
        (res) => {
          if (res.code == 200) {
            var arrList = res.data.data;
            for (var i = 0; i < arrList.length; i++) {
              arrList[i].isPlay = false;
              arrList[i].audioAddress = arrList[i].contentUrl;
              arrList[i].only = "only";
            }
            this.allNewAudio = this.allNewAudio.concat(arrList);

            var _index; //记录分页下标和详情返回下标
            this.allNewAudio.findIndex((res, index) => {
              if (res.id == arrList[0].id) {
                //找到分页第一条数据在list的位置
                _index = index;
              }
            });
            this.playIndex = _index;
            if (type) {
              //给最新分页数据渲染播放
              this.audioParams = this.allNewAudio[_index];
              this.audioParams.isPlay = true;
            } else {
              const {time,isStatus,item} = this.$store.state.AudioLinkage //取到首页过来的音频信息
              if(this.$store.state.AudioLinkage.item.audioName){ //刷新页面展示最新一条
                this.allNewAudio.unshift(item)
                this.audioParams = this.allNewAudio[0];
                if(isStatus){
                  this.audioParams.isPlay = true;
                  this.playTime = time;
                }else{
                  this.audioParams.isPlay = false;
                  this.playTime = time;
                  this.$refs.musicAudio.getTime();
                }
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.playTime = time;
                  }, 300);
                });
              }else{
                this.audioParams = arrList[0];
              }

            }

            this.totalElements = res.data.total;
            callback(res);
          }
        }
      );
    },
    // 播放全部
    playAll() {
      this.playIndex = 0;
      this.audioList.forEach((res, i) => {
        if (this.playIndex == i) {
          res.isPlay = true;
        } else {
          res.isPlay = false;
        }
      });
      this.audioParams = this.audioList[this.playIndex];
      this.audioParams = JSON.parse(
        JSON.stringify(this.audioParams).replace(/contentUrl/g, "audioAddress")
      );
    },
    // 开始播放
    startPlay(item, index) {
      if (!item.isPlay) {
        const { isios } = TestUserAgent();
        if (isios) {
          this.$refs.musicAudio.clearTime();
        }
        this.audioParams = item;
        this.addPlayNums(item.id, index);
      } else {
        //跳转详情
        this.onLinkTap(item, index);
      }
      this.audioList.forEach((res, i) => {
        if (index == i) {
          res.isPlay = true;
        } else {
          res.isPlay = false;
        }
      });
      this.playIndex = index;
      this.playSensor('开始')
    },
    // 组件点击跳详情
    senDetail(status) {
      //为true 走最新音频数据
      if (status) {
        this.onLinkTap(
          this.allNewAudio[this.playIndex],
          this.playIndex,
          this.allNewAudio[this.playIndex].authorId
        );
      } else {
        this.onLinkTap(
          this.audioList[this.playIndex],
          this.playIndex,
          this.audioList[this.playIndex].authorId
        );
      }
    },
    // 音频组件点击暂停
    PauseaudioParams(obj) {
      this.audioList.forEach((res) => {
        if (res.id === obj.id) {
          res.isPlay = false;
        }
      });
      this.$forceUpdate();
    },
    //音频组件点击播放
    PlayaudioParams(obj) {

      if (obj.only) {
        return false;
      }

      this.audioList.forEach((res) => {
        if (res.id === obj.id) {
          res.isPlay = true;
        }
      });
      this.$forceUpdate();
    },
    //切换下一个
    audioEvenTend(status) {
      if (status) {
        this.list = this.allNewAudio;
      } else {
        this.list = this.audioList;
      }
      if (
        this.index == this.list.length - 1 ||
        this.playIndex === this.list.length - 1
      ) {
        if (this.pageParams.audioFinished) {
          if (!this.audioParams.only) {
            this.playIndex = 0;
          }
        } else {
          this.getDataList(1);
        }
        //最新音频数据分页
        if (this.audioParams.only && this.list.length >= this.totalElements) {
          this.playIndex = 0;
        } else if (this.audioParams.only) {
          this.newPageParams.page++;
          this.getNewAudio(1);
        }
      } else {
        //详情返回给音频下标赋值
        if (this.index > 0) {
          this.playIndex = this.index;
        }
        this.playIndex++;
        this.index = 0; //赋值完成之后清除
        const { isios } = TestUserAgent();
        if (isios) {
          this.$refs.musicAudio.clearTime();
        }
      }
      this.list.forEach((res, i) => {
        if (this.playIndex == i) {
          res.isPlay = true;
        } else {
          res.isPlay = false;
        }
      });
      this.audioParams = this.list[this.playIndex];
      this.audioParams = JSON.parse(
        JSON.stringify(this.audioParams).replace(/contentUrl/g, "audioAddress")
      );
    },
  },
  filters: {
    //超过55加省略号
    exIntroFilter: function (text) {
      if (text && text.length >= 55) {
        return text.substring(0, 55) + "...";
      } else {
        return text;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit("changeIncludes", ["doctorHome", "cagechild"]);
    });
  },
  beforeRouteLeave (to, from, next) {
      if(to.path == '/cagechild'){ //跳转到凯琪首页存储当前音频数据
        if(this.$refs.musicAudio.$refs.player.paused){ //拿到音频的当前状态
          this.isStatus = 0
        }else{
          this.isStatus = 1
        }
        this.audioParams.isKq = 'kq'
        this.audioParams.only = 'only'
        this.$store.commit('addAudio',
        {
          item:this.audioParams,
          time:this.$refs.musicAudio.$refs.player.currentTime,
          isStatus:this.isStatus
        })
        this.$refs.musicAudio.$refs.player.load()
      }
      next()
  },
  activated() {
    const playStatus = sessionStorage.getItem("currentPlayStatus") || "";
    const { page, id, isNewAudio } = this.$store.state.recordAudio;
    // this.pageParams.page = page
    if (page != "" && id !== "" && playStatus !== "") {
      this.pageParams.loading = true;
      this.pageParams.audioFinished = false;
      this.audioList = [];
      this.allNewAudio = [];
      let pageArr = [];

      let i = 1;
      while (i <= page) {
        pageArr.push(i);
        i++;
      }

      let parama = pageArr.map((res) => {
        return new Promise((reslove) => {
          this.pageParams.page = res;
          if (isNewAudio) {
            this.newPageParams.page = res;
            this.getDataList();
            this.getNewAudio("", (k) => {
              reslove(k);
            });
          } else {
            this.pageParams.page = res;
            this.getDataList("", (k) => {
              reslove(k);
            });
          }
        });
      });
      Promise.all(parama)
        .then((result) => {
          console.log(result);
          let newaudioList = [];
          let n = 0;
          while (n <= result.length - 1) {
            //列表数据比最新音频数据多一个字段 listKqAudio
            newaudioList = newaudioList.concat(
              isNewAudio
                ? result[n].data.data
                : result[n].data.listKqAudio.data
            );
            n++;
          }
          if (isNewAudio) {
            this.list = this.allNewAudio = newaudioList;
            const {item} = this.$store.state.AudioLinkage //vuex数据继续添加到里面不然会有问题
            this.list.unshift(item)
          } else {
            this.list = this.audioList = newaudioList;
          }
          console.log(this.list);
          this.list.forEach((item, index) => {
            item.audioAddress = item.contentUrl;
          });
          var { audioTime, id } = this.$store.state.recordAudio;
          const _index = this.list.findIndex((res) => res.id === id);

          this.playIndex = _index;

          if (playStatus === "1") {
              setTimeout(()=>{
                this.playTime = audioTime;
              },300)
              this.list[_index].isPlay = true;

          } else {
            this.list[_index].isPlay = false;
            this.$refs.musicAudio.getTime(); //详情返回暂停设置播放位置
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.playTime = audioTime;
            }, 300);
          });
          this.audioParams = this.list[_index];
          this.index = _index; //详情返回给最新音频数据赋值下标
        })
        .catch(function (r) {
          console.log(r);
        });
    }
  },
};
</script>

<style lang='less' scoped>
//加载效果背景色
/deep/ .van-list__finished-text {
  background: #fff;
  padding-bottom: 180px;
}
/deep/ .van-loading--circular {
  background: #fff;
}
// 医生信息
.doctor_introduce {
  position: relative;
  width: 100%;
  height: auto;
  background: @expertFontColor255;
  border-bottom: 8px solid @expertBorderColor242;
  // 返回按钮
  .back {
    width: 26px;
    position: absolute;
    top: 7px;
    left: 10px;
    z-index: 1;
    .van-icon-arrow-left {
      font-size: @indexFontSize20;
      color: #1a1a1a;
    }
  }
  .gobackBtn {
    z-index: 20;
    width: 26px;
    position: absolute;
    top: 7px;
    left: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .doctor_bgimg {
    width: 100%;
    height: 162px;
    background-color: @expertBorderColor242;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
  }
  .doctor_info {
    padding: 16px 12px;
    .ex_name {
      color: @expertFontColor51;
      font-weight: 600;
      .name {
        margin-right: 12px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 16px;
      }
      .position {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #d4a437;
        line-height: 12px;
      }
    }
    .ex_intro {
      font-size: @indexFontSize12;
      color: @expertFontColor153;
      line-height: 18px;
      margin-top: 14px;
      span.more {
        color: #007aff;
      }
    }
  }
}
// 音频列表
.audioList {
  box-sizing: border-box;
  padding: 0px 12px 0px 12px;
  width: 100%;
  background: #ffffff;
  > .audioListTitle {
    display: flex;
    align-items: center;
    height: 51px;

    > img {
      width: 18px;
      height: 18px;
    }
    > p {
      margin-left: 4px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
    }
  }
  // 列表数据
  .audioLists {
    background: #fff;
    .audioItem:nth-of-type(1) {
      margin-top: 0px;
    }
    .audioItem {
      display: flex;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 4px 0px 4px 10px;
      height: 89px;
      > .leftImg {
        width: 20%;
        width: 72px;
        height: 72px;
        position: relative;
        > img {
          border-radius: 4px;
          width: 72px;
          height: 72px;
        }
        > .play {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 1;
          width: 30px;
          height: 30px;
        }
        .playing{
          width: 20px;
            height: 20px;
        }
      }
      > .titleText {
        float: right;
        width: 80%;
        height: 89px;
        border-bottom: 1px solid #f2f2f2;
        > div {
          box-sizing: border-box;
          padding: 0px 6px 0px 7px;
          > p:nth-child(1) {
            height: 35px;
            margin-bottom: 25px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          span {
            display: inline-flex;
            align-items: center;
            > img {
              width: 11px;
              height: 11px;
              margin-right: 4px;
            }
          }
          span:nth-child(2) {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
